export const getBase64 = (file, compressionPercentage = 1) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      const img = new Image();
      img.src = reader.result;

      img.onload = function () {
        const maxSize = 1 * 1024 * 1024; // 1MB in bytes

        const width = img.width * compressionPercentage;
        const height = img.height * compressionPercentage;

        // Create a canvas element
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        // Draw the image onto the canvas with the new dimensions
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Convert the canvas content to base64 as PNG to preserve transparency
        const compressedBase64 = canvas.toDataURL('image/png'); // Use PNG format

        const compressedSize = compressedBase64.length;

        // Check if compressed image size is within the desired range
        if (compressedSize <= maxSize) {
          resolve(compressedBase64);
        } else {
          // Recursively call getBase64 with a slightly more compressed image
          getBase64(file, compressionPercentage - 0.05)
            .then(resolve)
            .catch(reject);
        }
      };

      img.onerror = function (error) {
        reject(error);
      };
    };

    reader.onerror = function (error) {
      reject(error);
    };
  });
};


export const compressBase64Image = (base64String, compressionPercentage = 0.6) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64String;

    img.onload = function () {
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes

      const width = img.width * compressionPercentage;
      const height = img.height * compressionPercentage;

      // Create a canvas element
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      // Draw the image onto the canvas with the new dimensions
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      // Convert the canvas content to base64
      const compressedBase64 = canvas.toDataURL('image/png', 0.6); // Adjust quality as needed

      const compressedSize = compressedBase64.length;

      // Check if compressed image size is within the desired range
      if (compressedSize <= maxSize) {
        resolve(compressedBase64);
      } else {
        // Recursively call compressBase64Image with a slightly more compressed image
        compressBase64Image(base64String, compressionPercentage - 0.05)
          .then(resolve)
          .catch(reject);
      }
    };

    img.onerror = function (error) {
      reject(error);
    };
  });
};

export const getBase64FromCanvas = (canvas, compressionPercentage = 0.6) => {
  return new Promise((resolve, reject) => {
    const maxSize = 1 * 1024 * 1024; // 1MB in bytes

    const width = canvas.width * compressionPercentage;
    const height = canvas.height * compressionPercentage;

    // Create a temporary canvas element
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = width;
    tempCanvas.height = height;

    // Draw the original canvas onto the temporary canvas with the new dimensions
    const ctx = tempCanvas.getContext('2d');
    ctx.drawImage(canvas, 0, 0, width, height);

    // Convert the temporary canvas content to base64 as PNG to preserve transparency
    const compressedBase64 = tempCanvas.toDataURL('image/png'); // Use PNG format

    const compressedSize = compressedBase64.length;

    // Check if the compressed image size is within the desired range
    if (compressedSize <= maxSize) {
      resolve(compressedBase64);
    } else {
      // Recursively call getBase64FromCanvas with a slightly more compressed canvas
      getBase64FromCanvas(tempCanvas, compressionPercentage - 0.05)
        .then(resolve)
        .catch(reject);
    }
  });
};
